import React, { useEffect } from 'react';
import { Switch, Route, useHistory, useLocation, Redirect } from 'react-router-dom';

import MainLayout from '../layout/MainLayout';
import MinimalLayout from '../layout/MinimalLayout';
import FullScreenLayout from '../layout/FullScreenLayout';
import TopBarLayout from '../layout/TopBarLayout';

import Loading from '../components/loading/Loading';

import MediaMenu from '../pages/MediaMenu';
import Login from '../pages/Login';
import Error from '../pages/Error';
import SendList from '../pages/SendList';
import FbCreateData from '../pages/FbCreateData';
import GoogleCreateData from '../pages/GoogleCreateData';
import LineCreateData from '../pages/LineCreateData';
import TaboolaCreateData from '../pages/TaboolaCreateData';
import AdAccounts from '../pages/AdAccounts';
import CreateAdAccounts from '../pages/CreateAdAccounts';
import UserTerms from '../pages/UserTerms';
import Pravacy from '../pages/Pravacy';

import { apiList } from '../api/callAPI';

import useUser from '../hook/useUser';
import useGlobalStatus from '../hook/useGlobalStatus';

import * as basicConstants from '../constants/basic';
import * as alertConstants from '../constants/alertMsg';
import * as urlConstants from '../constants/url';
import * as mediaConstants from '../constants/mediaData';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }
  componentDidCatch(error, info) {
    this.setState({
      error: error,
      info: info
    })
    console.log(error, info)
  }
  render() {
    if (this.state.error) {
      return (
        <>
          <Error />
          {/* <details>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.info.componentStack}
          </details> */}
        </>
      )
    }
    return this.props.children;
  }
}

const RouteWrapper = ({ component: Component, layout: Layout, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <ErrorBoundary>
            {Layout ? (
              <Layout {...props}><ErrorBoundary><Component {...props} /></ErrorBoundary></Layout>
            ) : (
              <Component {...props} />
            )}
          </ErrorBoundary>
        )
      }}
    />
  )
}

const ProtectRouteWrapper = ({ component: Component, layout: Layout, allowedRoles, path, media, ...rest }) => {
  const { userData } = useUser();
  const { isLoadingLoginStatus } = useGlobalStatus();

  if (isLoadingLoginStatus) return null;
  if (!userData) return <Redirect to={urlConstants.PAGE_LOGIN} />;

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return (
          userData.scopes.find(type => allowedRoles.includes(type)) ? (
            <ErrorBoundary><Layout><ErrorBoundary><Component media={media} /></ErrorBoundary></Layout></ErrorBoundary>
          ) : (
            <ErrorBoundary><Redirect to={{ pathname: urlConstants.PAGE_MEDIA_MENU, state: { from: location } }} /></ErrorBoundary>
          ))
      }}
    />
  )
}

const AppRoute = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { isLoadingLoginStatus, setIsLoadingLoginStatus } = useGlobalStatus();
  const hasLogin = sessionStorage.getItem(basicConstants.SESSION_CREATE_TIME);

  useEffect(() => {
    if (userData ||
      location.pathname === urlConstants.PAGE_USERS_TERMS ||
      location.pathname === urlConstants.PAGE_PRIVACY) {
      setIsLoadingLoginStatus(false);
      return;
    }

    apiList.apiUserCheckStatus()
      .then(res => {
        if (res?.status === 200) {
          setUserData(res.data.result);
          setAuthStatusMsg('');
          if (!hasLogin) {
            sessionStorage.setItem(basicConstants.SESSION_CREATE_TIME, Date.now());
          }
          if (location.pathname === urlConstants.PAGE_LOGIN || location.pathname === "/") {
            history.push(urlConstants.PAGE_MEDIA_MENU);
          }

        } else if (res?.status === 401) {
          if (hasLogin) {
            setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          }

          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        }
        setIsLoadingLoginStatus(false);
      })
      .catch(err => {
        console.error('API request failed:', err);
        setAlertMsg(alertConstants.ERROR_SYSTEMCONNECT);
        setIsLoadingLoginStatus(false);
      });
  }, [location.pathname])

  return (
    <>
      <Switch>
        <RouteWrapper path={urlConstants.PAGE_LOGIN} component={Login} exact />
        <RouteWrapper path="/" component={Login} exact />

        <ProtectRouteWrapper
          path={urlConstants.PAGE_MEDIA_MENU}
          component={MediaMenu}
          layout={FullScreenLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT,
            basicConstants.AUTH_EDIT_REPORT,
            basicConstants.AUTH_BIND_AD_ACCOUNTS
          ]}
          media={mediaConstants.SYSTEM}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_FB_SEND_LIST}
          component={SendList}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          media={mediaConstants.FACEBOOK}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_FB_CREATE_DATA}
          component={FbCreateData}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_GOOGLE_SEND_LIST}
          component={SendList}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          media={mediaConstants.GOOGLE}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_GOOGLE_CREATE_DATA}
          component={GoogleCreateData}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_LINE_SEND_LIST}
          component={SendList}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          media={mediaConstants.LINE}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_LINE_CREATE_DATA}
          component={LineCreateData}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_TABOOLA_SEND_LIST}
          component={SendList}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          media={mediaConstants.TABOOLA}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_TABOOLA_CREATE_DATA}
          component={TaboolaCreateData}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_EDIT_REPORT
          ]}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_AD_ACCOUNTS}
          component={AdAccounts}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_BIND_AD_ACCOUNTS
          ]}
          exact
        />
        <ProtectRouteWrapper
          path={urlConstants.PAGE_AD_ACCOUNTS_CREATE}
          component={CreateAdAccounts}
          layout={MainLayout}
          allowedRoles={[
            basicConstants.AUTH_BIND_AD_ACCOUNTS
          ]}
          exact
        />

        <RouteWrapper
          path={urlConstants.PAGE_USERS_TERMS}
          component={UserTerms}
          layout={TopBarLayout}
          exact
        />

        <RouteWrapper
          path={urlConstants.PAGE_PRIVACY}
          component={Pravacy}
          layout={TopBarLayout}
          exact
        />

        <RouteWrapper path="*" component={Error} layout={MinimalLayout} />

      </Switch>

      <Loading isLoading={isLoadingLoginStatus} />
    </>
  )
}

export default AppRoute;